module.exports = __webpack_public_path__ + "img/steak-icon.5c47bf4a.svg";